import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllfund } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import { Grid } from "@material-ui/core";
import { getAllPaymentMethod } from "../../../services/paymentMethod";
import ConfirmDialogAddNumber from "../global/ConfirmDialogAddNumber";
import ConfirmDialogListNumber from "../global/ConfirmDialogListNumber";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Checkbox, FormControlLabel } from "@mui/material";
import ConfirmDialog from "../global/ConfirmDialogCon";

import packageJson from "../../../../package.json";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function ConvertUnite() {
  const navigate = useNavigate();
  const [fund, setfund] = useState([]);
  const [isDebt, setIsDebt] = useState(0); // Default to unchecked

  const [paymentMethod, setPaymentMethod] = useState([]);
  const [fundvalue, setFundvalue] = useState([]);
  const convert_mobile = localStorage.getItem("convert_mobile");

  const [mobile_number, setMobile_number] = useState(convert_mobile);
  const [fundpost, setFundpost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredFund, setFilteredFund] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data1, setdata1] = useState("");
  const [data2, setdata2] = useState("");
  const [Description, setDescription] = useState("");
  const [message, setmessage] = useState("");
  const [ServicesData, setServices] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog1, setConfirmDialog1] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  useEffect(() => {
    setIsLoading(true);
    getAllfund()
      .then((res) => {
        setfund(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
    getAllPaymentMethod()
      .then((res) => {
        setPaymentMethod(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
      getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  console.log(ServicesData,'ServicesData');
  const initialFValues = {
    mobile_number: "",
    fund_value_id: "",
    description: "",
    is_debt: "",
  };
  // {services.map((service) =>
  //   service.name == "TransferUnites" ? (
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (fieldValues.mobile_number === "") {
        temp.mobile_number = " رقم الموبايل مطلوب";
      } else if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }

    if ("fund_value_id" in fieldValues)
      temp.fund_value_id = fieldValues.fund_value_id ? "" : "  هذا الحقل مطلوب";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (
        fieldValues.mobile_number !== "" &&
        !/^[0-9]+$/.test(fieldValues.mobile_number)
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (
        fieldValues.mobile_number !== "" &&
        fieldValues.mobile_number.length !== 10
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else {
        temp.mobile_number = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const { loginInput, setLogin, errors, setErrors, addForm } = useForm(
    initialFValues,
    true,
    validate,
    validate2
  );

  const handleSubmit = () => {
   
   
    if (validate()) {
      setLoading(true);
      const data = {
        mobile_number: mobile_number,
        fund_value_id: fundpost,
        description: Description,
        trans_code: "prepaid",
        is_debt: isDebt,
      };
      axios
        .post(`${BaseUrl}/api/transferUnits`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            localStorage.setItem("convert_mobile", "");
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            });
          } else if (res.data.status === false) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.status === 500) {
            sweetalert(error.response.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          } else {
            // console.error("Unhandled error:", error);
            // sweetalert("حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى لاحقًا", {
            //   className: "alert-div",
            //   button: {
            //     text: "تم",
            //   },
            // });
          }
        });
    }
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;

    if (fieldName === "description") {
      validate();
      setDescription(value);
    }
    if (fieldName === "mobile_number") {
      validate();
      setMobile_number(value);
      const data = {
        mobile_number: value,
      };

      setLogin({ ...loginInput, mobile_number: e.target.value });
      axios
        .post(`${BaseUrl}/api/getFundValues`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status === 200) {
            setFundvalue(res.data.data);
          }
        })
        .catch((error) => {
          console.error("Error in API call:", error);
          // Handle errors as needed
        });
    } else if (fieldName === "fund_value_id") {
      setFundpost(value);
      setLogin({ ...loginInput, amount: e.target.value });
      setLogin({ ...loginInput, fund_value_id: e.target.value });
      const selectedFund = fundvalue.find(
        (opts) => opts.id === parseInt(value, 10)
      );
      setFilteredFund(selectedFund ? selectedFund : {});
    }
  };

  useEffect(() => {}, [message]);
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  function handleCheck() {
    let msg;
    const data = {
      phone: mobile_number,
    };
    axios
      .post(`${BaseUrl}/api/checkNumberExistsAlready`, data, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {
          setdata1(res.data.data);
          setmessage(res.data.msg);
          msg = res.data.msg;
        }
        setConfirmDialog({
          isOpen: true,
          title: res.data.msg,
          subTitle: "إضافة رقم الموبايل إلى سجل الارقام",
          onConfirm: () => {},
        });
      });
  }
  function handleListNumber() {
    axios
      .get(`${BaseUrl}/api/getMyCustomer`, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {
          setdata2(res.data.data);
          setmessage(res.data.msg);
        }
      });
    setConfirmDialog1({
      isOpen: true,
      title: "سجل الارقام",
      onConfirm: () => {},
    });
  }
  useEffect(() => {
    if (convert_mobile != "") {
      const data = {
        mobile_number: convert_mobile,
      };

      setLogin({ ...loginInput, mobile_number: convert_mobile });
      axios
        .post(`${BaseUrl}/api/getFundValues`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status === 200) {
            setFundvalue(res.data.data);
          }
        })
        .catch((error) => {
          console.error("Error in API call:", error);
          // Handle errors as needed
        });
    }
    setMobile_number(convert_mobile);
  }, [convert_mobile]);
  useEffect(() => {
    const convert_mobile = localStorage.getItem('convert_mobile');
    if(convert_mobile) {
      setMobile_number(convert_mobile);
      setLogin({ ...loginInput, mobile_number: convert_mobile });
      // Clear the local storage after setting the state
      localStorage.removeItem('convert_mobile');
    } else {
      setMobile_number('');
      setLogin({ ...loginInput, mobile_number: '' });
    }
  }, []);
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  return (
    <div className="main-div">

      <h3 className="titlepage">تحويل وحدات</h3>
      {
        ServicesData[1]?.name == "TransferUnites"  &&  ServicesData[1]?.is_active == 1? (
      <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={10} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={(e) => handleChange(e, "mobile_number")}
                value={mobile_number}
                className="form-control"
                error={errors.mobile_number}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <AddCircleIcon
                style={{ cursor: "pointer" }}
                className="svgadd"
                onClick={() => {
                  handleCheck();
                }}
              />
              <ConfirmDialogAddNumber
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                phone={mobile_number}
                data1={data1}
              />
              <AssignmentTurnedInIcon
                style={{ cursor: "pointer" }}
                className="svgadd1"
                onClick={() => {
                  handleListNumber();
                }}
              />
              <ConfirmDialogListNumber
                confirmDialog={confirmDialog1}
                setConfirmDialog={setConfirmDialog1}
                phone={mobile_number}
                data2={data2}
              />
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <label>قيمة الرصيد</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="fund_value_id"
                onChange={(e) => handleChange(e, "fund_value_id")}
                error={errors.fund_value_id}
              >
                <option selected disabled>
                  اختر قيمة الرصيد
                </option>
                {fundvalue.map((opts, i) => (
                  <option key={opts.id} value={opts.id}>
                    {opts.fund_value}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.fund_value_id == "" ? (
              <div style={{ color: "red", fontSize: "10px" }}>
                {errors.fund_value_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر الشراء"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={filteredFund?.fund_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={filteredFund?.sell_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <Controls.Input
              label="وصف"
              name="description"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "description")}
              value={Description}
              className="form-control"
              type="text"
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={isDebt === 1}
                  onChange={(e) => setIsDebt(e.target.checked ? 1 : 0)}
                  name="isDebt"
                  className="svgcheck"
                />
              }
              label="هل هو دين؟" // Replace with your label
            />
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <>

           
            <Controls.Button
              type="submit"
              text="تحويل"
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>

                 <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
               </>
          )}
        </Grid>
      </Grid>
                ):   ServicesData[1]?.name == "TransferUnites" &&
        ServicesData[1]?.is_active == 0 &&
        staff_type == "Admin" &&
        mobile_number_login == "0950555563" ?(
          <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={10} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={(e) => handleChange(e, "mobile_number")}
                value={mobile_number}
                className="form-control"
                error={errors.mobile_number}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <AddCircleIcon
                style={{ cursor: "pointer" }}
                className="svgadd"
                onClick={() => {
                  handleCheck();
                }}
              />
              <ConfirmDialogAddNumber
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                phone={mobile_number}
                data1={data1}
              />
              <AssignmentTurnedInIcon
                style={{ cursor: "pointer" }}
                className="svgadd1"
                onClick={() => {
                  handleListNumber();
                }}
              />
              <ConfirmDialogListNumber
                confirmDialog={confirmDialog1}
                setConfirmDialog={setConfirmDialog1}
                phone={mobile_number}
                data2={data2}
              />
            </Grid>
          </Grid>
          <Grid item md={6} xs={12}>
            <label>قيمة الرصيد</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="fund_value_id"
                onChange={(e) => handleChange(e, "fund_value_id")}
                error={errors.fund_value_id}
              >
                <option selected disabled>
                  اختر قيمة الرصيد
                </option>
                {fundvalue.map((opts, i) => (
                  <option key={opts.id} value={opts.id}>
                    {opts.fund_value}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.fund_value_id == "" ? (
              <div style={{ color: "red", fontSize: "10px" }}>
                {errors.fund_value_id}
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر الشراء"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={filteredFund?.fund_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={filteredFund?.sell_price || ""}
              className="form-control"
              type="number"
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <Controls.Input
              label="وصف"
              name="description"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "description")}
              value={Description}
              className="form-control"
              type="text"
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={isDebt === 1}
                  onChange={(e) => setIsDebt(e.target.checked ? 1 : 0)}
                  name="isDebt"
                  className="svgcheck"
                />
              }
              label="هل هو دين؟" // Replace with your label
            />
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <>

           
            <Controls.Button
              type="submit"
              text="تحويل"
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
                 <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
               </>
          )}
        </Grid>
      </Grid>
                                  
                ): ServicesData[1]?.name == "TransferUnites"  &&  ServicesData[1]?.is_active == 0?(
                  <div class="services-no-available">
                  هذه الخدمة غير متاحة
                  <img src="7703205.webp"/>

                  </div>
                                  ):(
                                    <></>)}
    </div>
  );
}
